export const faqData = {
	heading: {
		title: 'Frequently Asked Questions',
		subtitle: 'Who are in extremely love with eco friendly system.',
	},

	btnList: [
		{
			title: 'Are your Templates responsive?',
			txt:
				'Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget maximus est, id dignissim quam.',
		},
		{
			title: 'Does it have all ass mentioned?',
			txt:
				'Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget maximus est, id dignissim quam.',
		},
		{
			title: 'Can i use the Theme for my clients?',
			txt:
				'Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget maximus est, id dignissim quam.',
		},
		{
			title: 'Do you need more?',
			txt:
				'Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat. Aliquam eget maximus est, id dignissim quam.',
		},
	],
};
